import { render, staticRenderFns } from "./SummarizerEditor.vue?vue&type=template&id=91d2f00a&scoped=true"
import script from "./SummarizerEditor.vue?vue&type=script&lang=js"
export * from "./SummarizerEditor.vue?vue&type=script&lang=js"
import style0 from "./SummarizerEditor.vue?vue&type=style&index=0&id=91d2f00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d2f00a",
  null
  
)

export default component.exports